/**
 * Utility del campo Codice cliente dell'editor card.
 * @module flyers/utils/photoCodes
 */

// Il Codice cliente non deve mai contenere a capo (finisce in un tag dell'XML): un Invio
// nel campo diventa il separatore fra codici.
export function normalizeCustomerCodeInput(value)
{
	return String(value ?? "")
		.split(/[\r\n]+/)
		.map((part) => part.trim().replace(/^,|,$/g, "").trim())
		.filter(Boolean)
		.join(", ");
}
